module.exports = __webpack_public_path__ + "static/real-time-data-updates-08ab0dba3d2d120f03bc16a058de892d.png";